var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.5V10.2929L3.35355 6.14645C3.15829 5.95118 2.84171 5.95118 2.64645 6.14645C2.45118 6.34171 2.45118 6.65829 2.64645 6.85355L7.64645 11.8536C7.69439 11.9015 7.74964 11.9377 7.80861 11.9621C7.86756 11.9865 7.93221 12 8 12C8.06779 12 8.13244 11.9865 8.19139 11.9621C8.25036 11.9377 8.30561 11.9015 8.35355 11.8536L13.3536 6.85355C13.5488 6.65829 13.5488 6.34171 13.3536 6.14645C13.1583 5.95118 12.8417 5.95118 12.6464 6.14645L8.5 10.2929V0.5C8.5 0.223858 8.27614 0 8 0C7.72386 0 7.5 0.223858 7.5 0.5Z",
    fill: "#082644"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15.5C0.5 15.2239 0.723858 15 1 15H15C15.2761 15 15.5 15.2239 15.5 15.5C15.5 15.7761 15.2761 16 15 16H1C0.723858 16 0.5 15.7761 0.5 15.5Z",
    fill: "#082644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportButton);
export default __webpack_public_path__ + "static/media/export_button.795a24a12345fe021d2c55e2f8f8bb89.svg";
export { ForwardRef as ReactComponent };